var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-page-wrapper d-error-page"},[_c('div',{staticClass:"d-error-page-title",domProps:{"innerHTML":_vm._s(_vm.$t('errorPage.title'))}}),_c('router-link',{staticClass:"mt-6 d-block",attrs:{"to":{ name: 'home' }},domProps:{"innerHTML":_vm._s(_vm.$t('errorPage.backHome'))}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }